import { useRef, useState } from "react";

import { get_image_url, postMultipart } from "../api";
import {
  IconTrash,
  IconCirclePlus,
  IconCircleCheck,
} from "@tabler/icons-react";
import useImages from "../utils/use_images";
function EditItemImages({ item, onChange }) {
  const images = useImages();
  const [addOpen, setAddOpen] = useState(false);
  const [importingImage, setImportingImage] = useState(false);
  const fileImportRef = useRef(null);
  const handleClick = (e) => {
    fileImportRef.current?.click();
  };
  const handleSubmit = async (e) => {
    setImportingImage(true);
    const formData = new FormData();
    Array.from(e.target.files).forEach((x) => {
      formData.append(Array.from(e.target.files).indexOf(x), x);
    });

    const imageResponse = await postMultipart(`/images`, formData);
    imageResponse.forEach((image_id) => addImage(image_id));
    setImportingImage(false);
  };
  const addImage = (id) => {
    onChange({
      target: {
        name: "images",
        value: [...item.images, id],
      },
    });
  };
  const removeImage = (id) => {
    const newArray = item.images.filter((image) => image !== id);
    onChange({
      target: {
        name: "images",
        value: newArray,
      },
    });
  };
  return (
    <div className="overflow-x-auto">
      <div className="text-lg pb-2 font-semibold">Images</div>
      <div className="flex gap-2 h-56 overflow-x-auto">
        {item &&
          item.images?.map((image) => (
            <div
              key={image.image_id}
              className="relative border-2 border-black min-w-56 h-100"
            >
              <div className="absolute top-3 right-3">
                <button
                  onClick={() => removeImage(image)}
                  className="text-red-600 hover:text-red-400"
                >
                  <IconTrash className="w-8 h-8" />
                </button>
              </div>
              <img
                className="h-full object-cover"
                src={get_image_url(image)}
                alt="..."
              />
            </div>
          ))}
      </div>
      <div className="flex gap-2 m-2">
        <button
          onClick={() => setAddOpen(!addOpen)}
          className="rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Add
        </button>
        <button
          disabled={importingImage}
          onClick={handleClick}
          className="rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Import
        </button>
        <input
          ref={fileImportRef}
          name="image_id"
          accept="image/*"
          type="file"
          onChange={handleSubmit}
          className="hidden"
        />
      </div>
      {addOpen && (
        <div className="grid grid-cols-3 gap-2">
          {images.state.map((id) => (
            <div key={id} className="relative rounded-md m-1 hover:shadow-xl">
              <img
                className="w-32 h-32 object-cover"
                src={get_image_url(id)}
                alt="..."
              />
              <button
                onClick={() => addImage(id)}
                className="absolute top-2 right-2 m-auto"
              >
                {item.images.some((image) => image.image_id === id) ? (
                  <IconCircleCheck className="w-8 h-8 text-green-500 bg-gray-100 bg-opacity-75 rounded-lg" />
                ) : (
                  <IconCirclePlus className="w-8 h-8 bg-gray-100 bg-opacity-75 rounded-lg" />
                )}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
export default EditItemImages;
